import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt";

const GlobalDataTable = () => {
  const location = useLocation();

  useEffect(() => {
    const init = () => {
      if (!$.fn.DataTable) return;

      const $tables = $("table").not(".no-datatable");
      if ($tables.length === 0) return;

      $tables.each(function () {
        if ($.fn.DataTable.isDataTable(this)) {
          $(this).DataTable().destroy();
        }

        // Ambil teks header kolom pertama
        const firstHeader = $(this).find("thead th").first().text().trim().toLowerCase();

        // Cek apakah header pertama "no" atau "id"
        const isSmallFirstCol = firstHeader === "no" || firstHeader === "id";

        $(this).DataTable({
          responsive: true,
          pageLength: 10,
          lengthMenu: [5, 10, 25, 50],
          language: {
            search: "Cari:",
            lengthMenu: "Tampilkan _MENU_ data",
            info: "Menampilkan _START_ - _END_ dari _TOTAL_ data",
            zeroRecords: "Data tidak ditemukan",
            paginate: {
              next: "›",
              previous: "‹",
            },
          },
          columnDefs: isSmallFirstCol
            ? [
                {
                  targets: 0,
                  width: "50px",           // Lebar kecil kolom pertama
                  className: "dt-center",  // Rata tengah
                  orderable: false,        // Nonaktifkan sorting kolom pertama (opsional)
                },
              ]
            : [],
        });
      });
    };

    const timer = setTimeout(init, 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default GlobalDataTable;
